._section_8on31_1._section_8on31_1._section_8on31_1{display:grid;grid-template-columns:auto minmax(0,1fr) auto auto;grid-column:1 / -1}
